<template>
  <div id="app" role="main">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    document.body.className = (this.$route.path === '/') ? 'home' : 'toddy'
  }
}
</script>

<style lang="scss">
@import './scss/_mixins.scss';
@import 'bootstrap/dist/css/bootstrap.css';
@import 'bootstrap-vue/dist/bootstrap-vue.css';
$fa-font-path:  '~@fortawesome/fontawesome-free/webfonts' !default;
@import '~@fortawesome/fontawesome-free/scss/fontawesome.scss';
@import '~@fortawesome/fontawesome-free/scss/solid.scss';
@import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@500;600&display=swap');

html {
  scroll-behavior: smooth;
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
  text-shadow: 1px 1px 1px rgba(255,255,255,0.004);
  -webkit-text-stroke: 0.45px;
  -webkit-text-stroke: 0.45px rgba(255, 255, 255, 0.1);

  @include fluid-type();
}
html,
body
{
  --font-family-sans-serif: 'Avenir Next', 'Avenir', Helvetica, Arial, sans-serif !important;
  font-family: 'Avenir Next', 'Avenir', Helvetica, Arial, sans-serif;
}
body
{
  &.home
  {
    & > #app
    {
      display: table;
      width: 100%;
      height: 100vh;
      min-height: 100vh;
    }
  }

  &.toddy
  {
    display: flex;
    align-items: normal;
    justify-content: normal;
    background-color: white;

    & > #app
    {
      width: 100%;
      display: inherit !important;
      height: inherit !important;
      min-height: inherit !important;
    }
  }
}
.slcb-home__hero-wrap
{
  min-height: 100%;
  margin: 0;
  padding: 0;
  background: linear-gradient(90deg, #0F2558 0%, #4A73B0 100%);
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  color: #FFF;
}
.slcb-home__hero-wrap
{
  display: table-cell;
  vertical-align: middle;
}
.slcb-home__hero-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.slcb-home__hero-start-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
}
.slcb-home__hero-start-title-container {
  background: #FFF;
  border-bottom-right-radius: 50%;
  padding: 0 10% 0 5%;
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.slcb-home__hero-title
{
  font-family: 'Rajdhani', sans-serif;
  margin-bottom: 0;
  font-size: 460%;
  color: #626465;
  font-weight: 500;
}
.slcb-home__hero-title--sub
{
  font-family: 'Rajdhani', sans-serif;
  color: #626465;
  font-size: 400%;
  font-weight: 500;
  & span {
    color: #173680;
    font-weight: 600;
  }
}
.slcb-home__hero-text
{
  padding-top: 1rem;
  margin-bottom: 0;
  font-size: 2.5rem;
  line-height: 3.438rem;
}
.slcb-home__hero-start-toddy-container
{
  text-align: center;
  width: 35%;
  margin-right: 2.5%;
  padding: 2.5% 0;
  & > img {
    margin-bottom: 2.5rem;
  }
}
.slcb-home__hero-start-toddy
{
  font-family: 'Rajdhani', sans-serif;
  background-color: #FFF;
  border: 1px solid #FFF;
  padding: 1rem 3rem;
  border-radius: 6.25rem;
  font-size: 3.7rem;
  font-weight: 500;
  color: #173680;
  &:hover
  {
    color: #FFF;
    border-color: #FFF;
    background-color: #173680;
  }
}
.slcb-home__link-group
{
  font-size: 1rem;
  line-height: 1.25rem;
  margin: 0 auto 1rem;
}
.slcb-home__link
{
  color: #FFF;

  &:hover {
    color: #FFF;
    text-shadow: 0 0 0.625rem #fff;
  }
}
.slcb-home__powered-by
{
  text-align: center;
  margin: 2rem auto;
  color: #FFF;
  width: 100%;
  & > ul {
    padding: 0;
    margin: 0 auto 10px;
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
}
.slcb-home__powered-logo
{
  display: block;
  background-image: url('./assets/img/logo-white.png');
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 2.5rem;
  height: 2.5rem;
  margin: 0 auto;
}
.slcb-home__link--doted
{
  border-bottom: 0.0625rem dotted;
}
.slcb-toddy__view-content
{
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.slcb-toddy__header
{
  height: 100vh;
  background: linear-gradient(90deg, #0F2558 0%, #4A73B0 100%);
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  color: white;
  transition: .2s cubic-bezier(.55,0,.1,1);
}
.slcb-toddy__header--starting
{
  z-index: 999;
}
.slcb-toddy__header--closing,
.slcb-toddy__header--initiate
{
  height: 2.5rem;
}
.slcb-toddy__header--initiate
{
  @include box-shadow(0px 0.0625rem 0.25rem 0px rgba(0,0,0,0.12));
}
.slcb-toddy__header--initiate-fixed
{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: -1;
}
.slcb-toddy__header-title-container
{
  display: table;
  height: 100%;
}
.slcb-toddy__header-title-child-container
{
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.slcb-toddy__header-title
{
  font-weight: bold;
  font-size: 3.5rem;
  padding: 0;
  margin: 0;

  @media (min-width: 576px) {
    font-size: 4.5rem;
  }

  @media (min-width: 768px) {
    font-size: 5.5rem;
  }
}
.slcb-toddy__header-title--closing
{
  font-size: 1.5rem;
  line-height: 2rem;

  @media (max-width: 576px) {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.slcb-toddy__header-nav,
.slcb-toddy__header-nav-title-innercontainer
{
  position: relative;
  display: inline-block;
}
.slcb-toddy__header-nav
{
  float: left;
}
.slcb-toddy__header-nav-title-innercontainer
{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;

  @media (max-width: 576px) {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }
}
.slcb-toddy__header-nav-title-innercontainer
{
  text-align: center;
  @media (min-width: 768px) {
    text-align: center;
  }
}
.slcb-toddy__header-nav-title-innercontainer--right
{
  text-align: right;
  @media (min-width: 768px) {
    text-align: center;
  }
}
.slcb-toddy__header-nav-item
{
  position: relative;
  display: inline-block;
  color: #FFF;
  padding: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;

  img
  {
    padding: 0.5rem;
    border-radius: 1.25rem;
    margin-right: 0.125rem;
  }
  span
  {
    position: relative;
    top: 2px;
  }
  &:hover,
  &:focus
  {
    color: #FFF;
    text-decoration: none;
    img
    {
      background-color: #3386ff;
    }
  }
}
.slcb-toddy__header-nav-title
{
  font-weight: bold;
  font-size: 1.5rem;
  line-height: 2rem;

  @media (max-width: 576px) {
    font-size: 1rem;
    line-height: 1.94rem;
  }
}
.slcb-toddy__header-nav-title--sub-left
{
  position: relative;
  left: -0.969rem;
}
#terminal-chat
{
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 2rem;
  padding-bottom: 1rem;
}
.slcb-toddy__terminal-input-bg-container
{
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 99;
  background-color: #FAFAFA;
  padding: 30px 0px;
  transition: bottom .10s cubic-bezier(.55,0,.1,1);
}
.slcb-toddy__dialog,
.slcb-toddy__input
{
  font-size: 1rem;
  line-height: 1.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;

  @media (min-width: 768px) {
    font-size: 1.375rem;
    line-height: 1.875rem;
  }
}
.slcb-toddy__dialog-row--eq-height
{
  @include row-eq-height(768px);
}
.slcb-toddy__dialog-icon
{
  width: 3rem;
  margin-right: 0.9375rem;
  margin-bottom: 0.9375rem;
  border-radius: 2.188rem;
  overflow: hidden;
}
.slcb-toddy__dialog-icon-text
{
  width: 3rem;
  margin-left: 0.9375rem;
  margin-bottom: 0.9375rem;
}
.slcb-toddy__dialog-icon--text
{
  display: inline-block;
  padding: 0.7rem 0.5rem;
  width: 3rem;
  height: 3rem;
  margin: 0;
  font-weight: bold;
  text-transform: uppercase;
  color: #FFF;
  background-color: #000;
  font-size: 2rem;
  line-height: 1.8rem;
  text-align: center;
}
.slcb-toddy__dialog-text
{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
  p
  {
    margin: 0;
    width: 100%;
  }
}
.slcb-toddy__dialog-text--reply
{
  text-align: right;
  img
  {
    width: 100%;
    max-width: 350px;
    margin-right: 0;
    margin-left: auto;
  }
}
.slcb-toddy__dialog-button
{
  width: 100%;
  padding: 0.5rem;
  background-color: #3386FF;
  white-space: normal;
  font-weight: bold;
  color: white;
  font-size: 1rem;
  line-height: 1.5rem;
  cursor: pointer;

  -webkit-transition: all 250ms cubic-bezier(0.500, 0.250, 0.500, 0.750);
  -moz-transition: all 250ms cubic-bezier(0.500, 0.250, 0.500, 0.750);
  -o-transition: all 250ms cubic-bezier(0.500, 0.250, 0.500, 0.750);
  transition: all 250ms cubic-bezier(0.500, 0.250, 0.500, 0.750);

  -webkit-transition-timing-function: cubic-bezier(0.500, 0.250, 0.500, 0.750);
  -moz-transition-timing-function: cubic-bezier(0.500, 0.250, 0.500, 0.750);
  -o-transition-timing-function: cubic-bezier(0.500, 0.250, 0.500, 0.750);
  transition-timing-function: cubic-bezier(0.500, 0.250, 0.500, 0.750);

  @media (max-width: 768px) {
    margin: 0.9375rem auto;
  }

  @media (min-width: 768px) {
    height: 100%;
    max-width: 21.88rem;
  }

  &:hover,
  &:focus
  {
    @include box-shadow(0 1rem 2rem 0 rgba(51,134,255,0.24));

    -moz-transform: scale(1.07);
    -webkit-transform: scale(1.07);
    -o-transform: scale(1.07);
    transform: scale(1.07);
    color: #FFF;
  }
}
label, input {
  transition: all 0.2s;
  touch-action: manipulation;
}
::-webkit-input-placeholder {
  opacity: 0;
  transition: inherit;
}
.slcb-toddy__dialog-form-group
{
  position: relative;
  margin-top: 1.5rem;
  &:after
  {
    content: '';
    display: block;
    width: 100%;
    height: 0.25rem;
    background-color: #3386FF;
    border-radius: 2.188rem;
    position: relative;
  }
}
.slcb-toddy__dialog-form-group--opacity
{
  &:after
  {
    height: 1px;
    border: 2px solid #FFF;
    background-color: rgba(0,0,0,0.5);
    box-sizing: content-box;
  }
}
.slcb-toddy__dialog-label
{
  position: relative;
  display: block;
  float: left;
  font-size: 1.5rem;
  line-height: 1.75rem;
  font-weight: normal;
  left: 0.625rem;
  top: -2.5rem;
  pointer-events: none;
  margin: 0;
  -webkit-transition: all 250ms ease;
  -moz-transition: all 250ms ease;
  -o-transition: all 250ms ease;
  transition: all 250ms ease;
}
.slcb-toddy__dialog-label--opacity
{
  color: rgba(0,0,0,0.5);
}
.slcb-toddy__dialog-label--error
{
  color: red;
}
.slcb-toddy__dialog-input
{
  font-size: 1rem;
  line-height: 1.5rem;
  display: block;
  border-radius: 0;
  border: none;
  background-color: transparent;
  float: left;

  &.slcb-toddy__dialog-input--filled,
  &:focus
  {
    border: none;
    outline: none;
    box-shadow: none;
    background-color: transparent;

    & ~ .slcb-toddy__dialog-label
    {
      top: -4.625rem;
      @media (max-width: 576px) {
        top: -4.925rem;
      }
    }
    & ~ .slcb-toddy__dialog-label.slcb-toddy__dialog-label--opacity
    {
      font-size: 1rem;
      line-height: 1.5rem;
      font-weight: bold;
      color: #000;
      top: -4rem;
      @media (max-width: 576px) {
        top: -4.3rem;
      }
    }
    & ~ .slcb-toddy__dialog-form-group--opacity::after
    {
      background-color: #3386FF;
    }
  }

  @media (max-width: 576px) {
    line-height: 2.7rem;
  }
}
.slcb-toddy__dialog-input:focus + .slcb-toddy__dialog-button-input
{
  background-color: transparent !important;
  @include box-shadow(none);

  &:after
  {
    @include box-shadow(0 0.25rem 1rem 0 rgba(51, 134, 255, 0.74));
  }
}
.slcb-toddy__dialog-input--opacity
{
  float: none;
}
.slcb-toddy__dialog-input--arrow
{
  width: calc(100% - 72px);
}
.slcb-toddy__dialog-button-input
{
  display: inline-block;
  padding: 0.375rem 0;
  margin: 0;
  width: 72px;
  padding-right: 0;
  background-color: transparent !important;
  text-align: right;

  &:hover,
  &:focus
  {
    background-color: transparent !important;
    @include box-shadow(none);

    &:after
    {
      @include box-shadow(0 0.25rem 1rem 0 rgba(51, 134, 255, 0.74));
    }
  }

  &:after
  {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 0.25rem;
    background: #3485fb;
    left: 0;
    bottom: 0;
  }
}
.slcb-toddy__input-file
{
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  cursor: pointer;
  left: 0;
  top: 0;
}
.slcb-toddy__dropbox
{
  text-align: center;

  .fa-exclamation-circle
  {
    color: #dc3545;
    font-size: 8rem;
  }
}
.slcb-toddy__dropbox--waiting
{
  border: 0.0625rem dashed #C8C8C8;
  padding: 4% 20% 2.5%;
  border-radius: 0.9375rem;

  &:hover
  {
    background-color: lighten(#969696, 30%);
    cursor: pointer;
  }
}
.slcb-toddy__dropbox--uploading
{
  & .progress
  {
    height: 3.5rem;
    border: 0.25rem solid #3386FF;
    padding: 0.5rem;
    border-radius: 2.5rem;

    & .progress-bar
    {
      font-size: 1rem;
      font-weight: bold;
      background-color: #3386FF;
      border-radius: 2.5rem;
    }
  }
}
.slcb-toddy__dropbox-text
{
  color: #969696;
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 500;
  margin-bottom: 2rem;
}
.slcb-toddy__preview-image
{
  &,
  & caption
  {
    text-align: center;
  }

  & caption
  {
    display: block;
  }
}
.slcb-toddy__preview-image-figure
{
  & caption
  {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
.slcb-toddy__preview-image-innercontainer
{
  display: inline-block;
  position: relative;
  max-width: 12.5rem;
}
.slcb-toddy__cancel-button
{
  position: absolute;
  top: 4px;
  right: 4px;
  background-color: transparent;
  line-height: 4.063rem;
  white-space: normal;
  padding: 0;
  & i.fa
  {
    float: right;
    color: #FFF;
    font-size: 2.5rem;
    margin-left: 0.6250rem;

    &:before
    {
      float: right;
      padding: 0.75rem 1.141rem;
      background-color: #e24a4a;
      border-radius: 2.5rem;
    }
  }
  &:hover
  {
    & i.fa
    {
      &:before
      {
        background-color: darken(#e24a4a, 20);
      }
    }
  }
}
.slcb-toddy__class-box-master-container
{
  padding: 0 15px;
  max-height: 24.13rem;
  overflow-y: scroll;
  background-color: #fdfdfd;
}
.slcb-toddy__class-box
{
  overflow: hidden;
  border-radius: 0.25rem;
  padding: 2rem;
  margin: 1rem auto 0.5rem;
  -webkit-box-shadow: 0 0.125rem 0.25rem 0 rgba(204,204,204,0.8);
  -moz-box-shadow: 0 0.125rem 0.25rem 0 rgba(204,204,204,0.8);
  box-shadow: 0 0.125rem 0.25rem 0 rgba(204,204,204,0.8);
  background-color: #fff;
}
.slcb-toddy__class-box-label
{
  color: #000;
  font-size: 1.25rem;
  line-height: 1.5rem;
  font-weight: bolder;
  width: 100%;
  cursor: pointer;
}
.slcb-toddy__class-box-checkbox
{
  float: right;
  position: relative;
  width: 1.5rem;
  height: 1.5rem;
  @extend .fa;
  &:before
  {
    content: '';
    position: absolute;
    display: inline-block;
    width: 1.5rem;
    height: 1.5rem;
    background: #FFF;
    border: 0.125rem solid #A5AAB4;
    border-radius: 0.125rem;
  }
  &:after
  {
    content: '\f00c';
    position: absolute;
    display: inline-block;
    width: 1.5rem;
    height: 1.5rem;
    color: #FFF;
    visibility: hidden;
    top: 0.125rem;
    left: 0.125rem;
  }
  &:checked
  {
    &:before
    {
      background: #3386FF;
      border: 0.125rem solid #3386FF;
    }
    &:after
    {
      visibility: visible;
    }
  }
  &:hover,
  &:focus
  {
    outline: none;
    cursor: pointer;
  }
}
.slcb-toddy__class-box-text
{
  font-weight: normal;
  margin-top: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  display: block;
  max-height: 2.5rem;
  overflow: hidden;
}
.slcb-toddy__class-box-text--collapsed
{
  max-height: none;
}
.slcb-toddy__class-box-see-more
{
  position: relative;
  padding: 0;
  float: right;
  background-color: transparent;
  color: rgba(0,0,0,0.5);
  font-weight: bold;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.slcb-toddy__next-button-container
{
  position: relative;
  top: -1.5rem;
  background-color: rgba(255,255,255,0.74);
  padding-top: 4rem;
  text-align: center;
  -webkit-box-shadow: 0 -0.375rem 0.5rem 0 rgba(230,230,230,0.3);
  -moz-box-shadow: 0 -0.375rem 0.5rem 0 rgba(230,230,230,0.3);
  box-shadow: 0 -0.375rem 0.5rem 0 rgba(230,230,230,0.3);
}
.slcb-toddy__mini-box
{
  border-radius: 4px;
  background-color: #fff;
  padding: 1rem;
  margin-bottom: 1rem;
  -webkit-box-shadow: 0 0.125rem 0.25rem 0 rgba(204,204,204,0.8);
  -moz-box-shadow: 0 0.125rem 0.25rem 0 rgba(204,204,204,0.8);
  box-shadow: 0 0.125rem 0.25rem 0 rgba(204,204,204,0.8);
  span
  {
    display: block;
  }
  .slcb-toddy__mini-box-title
  {
    font-weight: bold;
  }
}
.slcb-toddy__dialog-error
{
  font-size: 1rem;
  line-height: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue